/*
 * Ajax : récupère la jauge pour le type d'espace choisi
 * active les autes éléments du formulaire
 */
function get_jauge_devis(selectSpace){
  // initialisation des variables
  var space    = '';
  var formData = new FormData();

  // récupération de la valeur du select
  space = selectSpace.value;

  // pas d'espace recherché --> verrouillage du formulaire
  if(space == 'none')
  {
    // on réinitialise le formulaire
    jQuery('select#edit-nombre-de-participants').html('<option>Nombre de participants</option>');
    jQuery('select#edit-nombre-de-participants').attr('disabled', 'disabled');
  }
  // callback ajax pour aller chercher les jauges correspondantes
  else
  {
    // récupération du type d'espace recherché
    formData.append('entity_space', space);
    formData.append('get_label', 1);
    // ajax
    jQuery.ajax({
      type: "POST",
      url: '/ajax/search_space_jauge',
      data: formData,
      async: true,
      processData: false,
      contentType: false
    })
    .done(function(result){
      if(result.options)
      {
        // on implemente les resultats
        jQuery('select#edit-nombre-de-participants').removeAttr('disabled');
        jQuery('select#edit-nombre-de-participants').html(result.options);
      }
    })
    .fail(function(){
      console.log('fail');
    });
  }
  // fin if(space == 'none')
}
